/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Stack } from '@mui/material';
import { ArquivoContainerV2 } from '../../../../../components/v2';
import InformacoesCampoSecao from './InformacoesCampoSecao';
import ServicosCampoSecao from './ServicosCampoSecao';

const semAlteracao = () => {};

/**
 * Metade de cima da visão de Digitação: o que o inspetor levantou em campo, em leitura.
 * O formulário de digitação continua no DefaultModal, logo abaixo.
 */
const VisaoDigitacaoNsmp = ({ values, procedimentos, onAbrirDocumento }) => {
  const topoRef = useRef(null);
  const fotos = values.fotos || [];

  // Ao avançar para a próxima NSMP o conteúdo do modal deve voltar ao topo.
  useEffect(() => {
    topoRef.current?.scrollIntoView?.({ block: 'start' });
  }, [values.id]);

  return (
    <Box ref={topoRef} sx={{ scrollMarginTop: 16 }}>
      <Stack spacing={1.5}>
        <InformacoesCampoSecao values={values} />
        <ServicosCampoSecao
          nsmpId={values.id}
          servicos={values.servicos}
          servicoTexto={values.servico}
          procedimentos={procedimentos}
          onAbrirDocumento={onAbrirDocumento}
        />
        <Grid container>
          <ArquivoContainerV2
            collapse
            hasAdd={false}
            showDelete={false}
            initialExpanded={false}
            headerTitle={`Fotos · ${fotos.length}`}
            arquivos={fotos}
            onSave={semAlteracao}
          />
        </Grid>
      </Stack>
    </Box>
  );
};

VisaoDigitacaoNsmp.propTypes = {
  values: PropTypes.object.isRequired,
  procedimentos: PropTypes.object,
  onAbrirDocumento: PropTypes.func,
};

VisaoDigitacaoNsmp.defaultProps = {
  procedimentos: null,
  onAbrirDocumento: undefined,
};

export default VisaoDigitacaoNsmp;
